<p>set-client works!</p>
